var actions, types;

types = {
  INVALIDATE_GAMES: 'invalidate-games',
  REQUEST_GAMES: 'request-games',
  RECEIVE_GAMES: 'receive-games',
  CREATE_NEW_GAME: 'create-new-game',
  DESTROY_GAME: 'destroy-game',
  JOIN_GAME: 'join-game',
  GET_READY: 'get-ready',
  START_GAME: 'start-game',
  LEAVE_GAME: 'leave-game',
  PICK_CARD: 'pick-card',
  PICK_WINNER: 'pick-winner'
};

actions = {
  invalidateGames: function() {
    return {
      type: types.INVALIDATE_GAMES
    };
  },
  requestGames: function() {
    app.socket.emit('data', {
      endpoint: '/games/list'
    });
    return {
      type: types.REQUEST_GAMES
    };
  },
  createNewGame: function(name) {
    app.socket.emit('data', {
      endpoint: '/games/create',
      value: name
    });
    return {
      type: types.CREATE_NEW_GAME
    };
  },
  destroyGame: function(id) {
    app.socket.emit('data', {
      endpoint: '/games/destroy',
      value: id
    });
    return {
      type: types.DESTROY_GAME
    };
  },
  joinGame: function(id) {
    app.socket.emit('data', {
      endpoint: '/games/join',
      value: id
    });
    return {
      type: types.JOIN_GAME
    };
  },
  getReady: function(id) {
    app.socket.emit('data', {
      endpoint: '/games/ready',
      value: id
    });
    return {
      type: types.GET_READY
    };
  },
  startGame: function(id) {
    app.socket.emit('data', {
      endpoint: '/games/start',
      value: id
    });
    return {
      type: types.START_GAME
    };
  },
  leaveGame: function(id) {
    app.socket.emit('data', {
      endpoint: '/games/leave',
      value: id
    });
    return {
      type: types.LEAVE_GAME
    };
  },
  pickCard: function(id, card) {
    app.socket.emit('data', {
      endpoint: '/games/pick',
      value: {
        gameId: id,
        card: card
      }
    });
    return {
      type: types.PICK_CARD
    };
  },
  pickWinner: function(id, userId) {
    app.socket.emit('data', {
      endpoint: '/games/winner',
      value: {
        gameId: id,
        userId: userId
      }
    });
    return {
      type: types.PICK_WINNER
    };
  },
  receiveGames: function(items) {
    return {
      type: types.RECEIVE_GAMES,
      games: items,
      receivedAt: Date.now()
    };
  }
};

Object.assign(actions, types);

module.exports = actions;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/actions/games.coffee
 ** module id = 245
 ** module chunks = 0
 **/